import { ConnectedHistoricalChart, Resolutions } from '@innovyze/summaryze';
import React, { Dispatch, SetStateAction } from 'react';
import { HistoricalChartConnected } from '@innovyze/summaryze';
import { SimulationPrimarySeries, StylovyzeDialog } from '@innovyze/stylovyze';
import styled from 'styled-components';
import { useGlobalization } from '@Translations/useGlobalization';

export interface SensorHistoryDialogProps {
	title: string;
	id?: string;
	alias?: string;
	modalOpen: boolean;
	closeModal: () => void;
	setWorkspaceModalOpen?: Dispatch<SetStateAction<boolean>>;
	goToSensorEdit?: () => void;
	primarySeries?: HistoricalChartConnected['primarySeries'] & {
		simulation?: SimulationPrimarySeries & { modellingId?: string };
	};
}

const StyledConnectedHistoricalChart = styled.div`
	min-width: 30rem;
	margin: auto;
	&:first-child {
		height: 537px;
	}
`;

export default function SensorHistoryDialog({
	title,
	id,
	alias,
	modalOpen,
	closeModal,
	setWorkspaceModalOpen,
	primarySeries,
}: SensorHistoryDialogProps): React.ReactElement {
	const { t } = useGlobalization();
	const resolution = Resolutions['15 Minutes'];
	const confirmText = setWorkspaceModalOpen
		? t('Add to Workspace', {
				context: 'Sensor history dialog add to workspace button',
		  })
		: undefined;
	return (
		<StylovyzeDialog
			title={title}
			open={modalOpen}
			cancelText={t('Close', {
				context: 'Sensor history dialog close button',
			})}
			confirmText={confirmText}
			onConfirm={() => {
				if (!setWorkspaceModalOpen) {
					return;
				}
				setWorkspaceModalOpen(true);
			}}
			onCancel={() => {
				closeModal();
			}}>
			<StyledConnectedHistoricalChart>
				<ConnectedHistoricalChart
					id={id ?? primarySeries?.id}
					displayOptions={{}}
					primarySeries={
						primarySeries
							? primarySeries
							: {
									id: id ?? '',
									alias: alias ?? '',
									displayOptions: {},
									func: 'Average',
									resolution,
									unit: '',
							  }
					}
					separateYAxes={[]}
				/>
			</StyledConnectedHistoricalChart>
		</StylovyzeDialog>
	);
}
